export default __webpack_public_path__ + "static/grid-b92ca1cc4920bc91500b37b355d2c1f6.svg";